import React, {FC, useEffect, useRef, useState} from "react";
import {IProduct, TranslationsType} from "../../../types/homePageTypes";
import ProductCard from "../../ForCWV/Products/ProductCard";
import cls from "../../ForCWV/Products/products.module.scss";
import BlockHeaderCustom from "../../shared/BlockHeaderCustom";
import animCls from "../builder.module.scss"
import Slider from "react-slick";
import {CarouselArrowNext, CarouselArrowPrev} from "../../../svg";

interface IProps {
    item: {
        customClassNames: string;
        productListComponentInfo: {
            products: Array<IProduct>,
            block_title: string,
            showAsSlider: boolean
        },
        showProductListCls: string,
        convertedSettings: {
            animationAos: {
                "data-aos": string
            },
            styles: any;
            parentStyles: any
        };
        hoverAnimation: string
    }
    dbName: string;
    translationsData: TranslationsType;
    backOrderValue: string;
    selectedCurrItems: {
        selectedCurrCode: string;
        selectedCurrRate: string;
        selectedCurrSymbol: string
    };
    selectedLocale: string;
    isMobile: boolean
}

const Index: FC<IProps> = (
    {
        item: {
            productListComponentInfo: {
                products = [],
                block_title = "",
                showAsSlider
            } = {},
            showProductListCls = "",
            convertedSettings: {
                animationAos: {"data-aos": dataAos = "none"} = {},
            } = {},
            customClassNames,
            hoverAnimation
        } = {},
        isMobile,
        ...pageProps
    }
) => {
    const ref = useRef<HTMLDivElement>(null)
    const [originalProducts, setOriginalProducts] = useState<boolean>(false);

    const handleBlockTitle = {
        true: {
            true: <div>
                <BlockHeaderCustom title={block_title}/>
            </div>,
            false: null
        },
        false: {
            true: null,
            false: null
        }
    }

    useEffect(() => {
        const handleScroll = () => {
            if (ref && ref.current) {
                setOriginalProducts(window.scrollY >= ref.current?.offsetTop - 2)
            }
        }
        if (!originalProducts && isMobile) {
            window.addEventListener("scroll", handleScroll)
        } else {
            window.removeEventListener("scroll", handleScroll)
        }
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])

    const sliderResponsiveSettings = {
        responsive: [
            { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 3 } },
            { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        ]
    };

    const displayedProducts = isMobile && !originalProducts
        ? products.filter((_, index) => index < 4)
        : products;

    return <div data-aos={dataAos} className={`${customClassNames} ${animCls[hoverAnimation ?? "none"]}`}>
        {handleBlockTitle[`${!!products.length}`][`${!!block_title}`]}
        <div className={cls["block-products__body"]}>
            {showAsSlider && displayedProducts.length > 4 ?
                <>
                    <div className={cls.product_list__slider} style={{width: "100%"}}>
                        <Slider
                            dots={true}
                            arrows={true}
                            infinite={false}
                            slidesToShow={4}
                            slidesToScroll={4}
                            nextArrow={<CarouselArrowNext />}
                            prevArrow={<CarouselArrowPrev />}
                            {...sliderResponsiveSettings}
                        >
                            {displayedProducts.map((product: IProduct, index: number) => {
                                return (
                                    <div key={product.id} style={{minHeight: 200}} className={cls["product-card-parent"]}>
                                        <div ref={!originalProducts ? ref : null} className={cls["block-products__list-item"]}>
                                            <ProductCard
                                                product={product}
                                                priority={index < 2}
                                                {...pageProps}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                        </Slider>
                    </div>
                </>
                : <div className={cls["block-products__list"]}>
                    {displayedProducts.map((product: IProduct, index: number) => {
                        return (
                            <div key={product.id} style={{minHeight: 200}} className={cls["product-card-parent"]}>
                                <div ref={!originalProducts ? ref : null} className={cls["block-products__list-item"]}>
                                    <ProductCard
                                        product={product}
                                        priority={index < 2}
                                        {...pageProps}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>
            }
        </div>
    </div>
}

export default Index;